import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AvatarComponent, SharedModule } from '@blaze-shared/shared-feature';

import { ActionBarComponent } from './action-bar/action-bar.component';
import { ActionBarNavComponent } from './action-bar-nav/action-bar-nav.component';
import { ActionBarUserComponent } from './action-bar-user/action-bar-user.component';

const STANDALONE_COMPONENTS = [
  ActionBarComponent,
  ActionBarNavComponent,
  ActionBarUserComponent,
  AvatarComponent,
];

@NgModule({
  imports: [CommonModule, SharedModule, ...STANDALONE_COMPONENTS],
  exports: [...STANDALONE_COMPONENTS],
})
export class ActionBarModule {}
